var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useReducer } from 'react';
import { gql } from '@apollo/client';
import { AcceptVtoActions } from './AcceptVtoContextTypes';
var AcceptVtoContext = React.createContext([
    { selectedVto: null },
    function () {
        /** noop */
    }
]);
export var AcceptVtoReducer = function (state, action) {
    switch (action.type) {
        case AcceptVtoActions.SetSelectedVto:
            var vto = action.payload.vto;
            return __assign(__assign({}, state), { selectedVto: vto });
        default:
            return state;
    }
};
export var AcceptVtoContextProvider = function (_a) {
    var vto = _a.vto, children = _a.children;
    var state = {
        selectedVto: vto !== null && vto !== void 0 ? vto : null
    };
    return (React.createElement(AcceptVtoContext.Provider, { value: useReducer(AcceptVtoReducer, state) }, children));
};
export var useAcceptVtoContext = function () {
    return React.useContext(AcceptVtoContext);
};
AcceptVtoContextProvider.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment AcceptVtoContextProvider_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "], ["\n        fragment AcceptVtoContextProvider_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n                duration {\n                    value\n                }\n            }\n        }\n    "])))
};
var templateObject_1;
